// extracted by mini-css-extract-plugin
export default {"productDescription":"uaa-z","featuredDescription":"vaa-z","description":"waa-z","more":"xaa-z","descriptionSku":"yaa-z"};